export class Location {
  id: string;
  name: string;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.name = payload.name;
    }
  }

  static createLocations(result: Array<any>): Location[] {
    const locations = new Array<Location>();
    if (result) {
      result.map((location) => {
        locations.push(new Location(location));
      });
    }
    return locations;
  }
}
